var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "data-testid": "confirmation-modal",
                "max-width": "600px",
              },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "secondary white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "header-font",
                          staticStyle: { "font-size": "22px" },
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.title)))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "pt-0" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "body-1 primary--text" },
                                    [_vm._v(_vm._s(_vm.$t(_vm.message)))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "d-flex justify-end pr-6 pb-4" },
                    [
                      _vm.showNoButton
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "elevation-0 monospace-font px-4",
                              attrs: {
                                "data-testid": "confirmation-no",
                                color: _vm.$vuetify.theme.dark
                                  ? "white"
                                  : "secondary",
                                rounded: "",
                                outlined: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onConfirmationClick(false)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t(_vm.noLabel)))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          ref: "confirmationButton",
                          staticClass:
                            "elevation-0 monospace-font white--text px-4",
                          attrs: {
                            "data-testid": "confirmation-yes",
                            rounded: "",
                            color: "primary",
                            loading: _vm.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onConfirmationClick(true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.yesLabel)))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }